/**
 *
 * Asynchronously loads the component for ToastMessages
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
